'use client';

import React from 'react';
import { m } from 'motion/react';

interface DrawPathProps extends React.SVGProps<SVGPathElement> {
  d: string;
  /** Seconds before the stroke starts */
  delay?: number;
  duration?: number;
}

/** A hand-drawn stroke that draws itself in when scrolled into view (Storybook doodles). */
export function DrawPath({ d, delay = 0.3, duration = 1.4, className, style }: DrawPathProps) {
  return (
    <m.path
      d={d}
      className={className}
      style={style}
      initial={{ pathLength: 0 }}
      whileInView={{ pathLength: 1 }}
      viewport={{ once: true }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
    />
  );
}
